import { useState } from 'react';
import { useTheme } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import { useHasAiQaAccess } from 'src/hooks/hooks';
import { AiQaScore } from 'src/services/insights/types';

export const useAiQaTabs = (aiQaScores: AiQaScore[] | undefined) => {
  const { palette } = useTheme();
  const hasAiQaPermission = useHasAiQaAccess();

  const [selectedTab, setSelectedTab] = useState(0);
  const showAiQaTab = hasAiQaPermission && aiQaScores && aiQaScores.length > 0;

  const getTabLabel = (label: string, index: number) => (
    <Typography
      color={selectedTab === index ? undefined : palette.colors.grey[500]}
      key={label}
      variant={selectedTab === index ? 'font14Bold' : 'font14'}
    >
      {label}
    </Typography>
  );
  const tabs = [getTabLabel('Conversation', 0), getTabLabel('AI QA', 1)];

  return { selectedTab, setSelectedTab, showAiQaTab, tabs };
};
